import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../Actions/customerActions";
export default function useCustomerFetchAddress(form) {
    const dispatch = useDispatch();
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    
    useEffect(() => {
        if (form?.data?.fetchAddress === undefined) return;

        customerActions.updateVossCustomerFromBusinessCheck(form?.data?.organizationNumber, form);

    }, [form?.data.fetchAddress]);

}